import React from 'react'
import styled, { css } from 'styled-components'
import { COLOR, FONT_SIZE, SIDE_BAR, Z_INDEXS } from '../../themes'

const widthCalculate = (position) => {
  if (position === 'left') {
    return css`
      width: calc((100% / 3) * ${(props) => props.textCenter ? 1 : 2});
    `
  }
  return css`width: calc(100% / 3);`
}
export default styled.div`
  align-items: center;
  background-color: ${COLOR.WHITE};
  display: flex;
  font-size: ${FONT_SIZE.XXS};
  flex-direction: row;
  height: ${(props) => props.height};
  justify-content: space-between;
  position: fixed;
  width: calc(100% - ${SIDE_BAR.WIDTH_SIZE});
  max-width: calc(1920px - ${SIDE_BAR.WIDTH_SIZE});
  z-index: ${Z_INDEXS.LV_7};

  > .top-bar__left {
    align-items: center;
    display: flex;
    margin-left: 32px;
    text-align: start;
    ${widthCalculate('left')}

    > .text-breadcrumb__start {
      ${(props) => {
      if (props.textEnd) {
        return css`
          color: ${COLOR.GRAY_27};
          cursor: pointer;
          font-family: NunitoSansRegular;
          &:hover {
            color: #666666;
          }
        `
      }
      return css`
        font-family: NunitoSansBold;
        color: ${COLOR.BLACK_6};
        ${(props) => {
          if (props.isTextStartBig) {
            return css `
              font-family: LibreBaskervilleBold;
              font-size: ${FONT_SIZE.MD};
              margin: 10px 50px 0 18px;
            `
          }
        }}
      `
      }}
    }

    > .text-breadcrumb__start--static {
      color: ${COLOR.GRAY_27};
      font-family: NunitoSansRegular;
    }

    > .text-arrow {
      color: ${COLOR.GRAY_27};
      font-family: NunitoSansRegular;
      display: inline-block;
      margin: 0 6px;
    }

    > .text-breadcrumb__end {
      font-family: NunitoSansBold;
      color: ${COLOR.BLACK_6};
    }
  }

  > .top-bar__center {
    font-family: NunitoSansRegular;
    text-align: center;
    color: ${COLOR.BLACK_6};
    ${widthCalculate()}
  }

  > .top-bar__right {
    margin-right: 32px;
    text-align: end;
    ${widthCalculate()}
  }
`

export const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={COLOR.GRAY_3}
    width="7"
    height="11"
    viewBox="0 0 11.681 18"
  >
    <path d="M9,11.681l-9-9L2.681,0,9,6.319,15.319,0,18,2.681Z" transform="translate(0 18) rotate(-90)" />
  </svg>
)




